import { Link } from "react-router-dom";

const ContactInner = () => {
  return (
    <>
      <section className='contact py-120' style={{ paddingTop: '10px' }}>
        <div className='container'>
          <div className='section-heading text-center'>
            <div className='flex-align d-inline-flex gap-8 mb-16'>
              <span className='text-main-600 text-2xl d-flex'>
                <i className='ph-bold ph-users' />
              </span>
              <h5 className='text-main-600 mb-0'>Hubungi Kami</h5>
            </div>
            <h2 className='mb-24'>Konsultasi Penelitian Anda</h2>
            <p className=''>
              Vice Research siap membantu penelitian Anda dengan layanan konsultasi profesional untuk skripsi, tesis, disertasi, dan publikasi jurnal
            </p>
          </div>
          <div className='row gy-4'>
            <div className='col-xl-4 col-md-6'>
              <div className='contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600'>
                <span className='contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0'>
                  <i className='ph ph-map-pin-line' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='mb-12'>Lokasi Kami</h4>
                  <p className='text-neutral-500'>
                    Perumahan Teras Alam No.B1,<br />
                    Desa Tambakromo, Kecamatan Geneng,<br />
                    Kabupaten Ngawi, Jawa Timur
                  </p>
                  <Link
                    to='https://maps.app.goo.gl/your-maps-link'
                    className='text-main-600 fw-semibold text-decoration-underline mt-16'
                  >
                    Lihat di Maps
                  </Link>
                </div>
              </div>
            </div>
            <div className='col-xl-4 col-md-6'>
              <div className='contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600'>
                <span className='contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0'>
                  <i className='ph ph-envelope-open' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='mb-12'>Email</h4>
                  <p className='text-neutral-500'>RHresearch30@gmail.com</p>
                  <a
                    href='mailto:RHresearch30@gmail.com'
                    className='text-main-600 fw-semibold text-decoration-underline mt-16'
                  >
                    Kirim Email
                  </a>
                </div>
              </div>
            </div>
            <div className='col-xl-4 col-md-6'>
              <div className='contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600'>
                <span className='contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0'>
                  <i className='ph ph-whatsapp-logo' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='mb-12'>WhatsApp</h4>
                  <p className='text-neutral-500'>0831 3148 7736</p>
                  <a
                    href='https://wa.me/6283131487736'
                    className='text-main-600 fw-semibold text-decoration-underline mt-16'
                  >
                    Chat WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='contact-form-section py-240 bg-main-25 position-relative z-1'>
        <img
          src='assets/images/bg/wave-bg.png'
          alt=''
          className='position-absolute top-0 start-0 w-100 h-100 z-n1 d-lg-block d-none'
        />
        <div className='container'>
          <div className='row gy-5 align-items-center'>
            <div className='col-xl-7 col-lg-6 pe-lg-5'>
              <div className='mb-40 md-xl-5'>
                <div className='flex-align d-inline-flex gap-8 mb-16'>
                  <span className='text-main-600 text-2xl d-flex'>
                    <i className='ph-bold ph-clipboard-text' />
                  </span>
                  <h5 className='text-main-600 mb-0'>Formulir Konsultasi</h5>
                </div>
                <h2 className='mb-24'>
                  Mulai Konsultasi Penelitian Anda
                </h2>
                <p className='text-neutral-500 text-line-3 max-w-636'>
                  Vice Research siap membantu Anda menyelesaikan penelitian dengan layanan konsultasi profesional dari tim ahli kami
                </p>
              </div>
            </div>
            <div className='col-xl-5 col-lg-6'>
              <div className='p-24 bg-white rounded-12 box-shadow-md'>
                <div className='border border-neutral-30 rounded-8 bg-main-25 p-24'>
                  <form action='#' id='consultationForm'>
                    <h4 className='mb-0'>Formulir Konsultasi</h4>
                    <span className='d-block border border-neutral-30 my-24 border-dashed' />
                    <div className='mb-24'>
                      <label htmlFor='name' className='text-neutral-700 text-lg fw-medium mb-12'>
                        Nama Lengkap
                      </label>
                      <input
                        type='text'
                        className='common-input rounded-pill border-transparent focus-border-main-600'
                        id='name'
                        placeholder='Masukkan nama lengkap...'
                      />
                    </div>
                    <div className='mb-24'>
                      <label htmlFor='phone' className='text-neutral-700 text-lg fw-medium mb-12'>
                        WhatsApp
                      </label>
                      <input
                        type='tel'
                        className='common-input rounded-pill border-transparent focus-border-main-600'
                        id='phone'
                        placeholder='Masukkan nomor WhatsApp...'
                      />
                    </div>
                    <div className='mb-24'>
                      <label htmlFor='service' className='text-neutral-700 text-lg fw-medium mb-12'>
                        Layanan
                      </label>
                      <select
                        className='common-input rounded-pill border-transparent focus-border-main-600'
                        id='service'
                      >
                        <option value=''>Pilih Layanan...</option>
                        <option value='skripsi'>Konsultasi Skripsi</option>
                        <option value='tesis'>Konsultasi Tesis</option>
                        <option value='disertasi'>Konsultasi Disertasi</option>
                        <option value='jurnal'>Publikasi Jurnal</option>
                        <option value='olahdata'>Pengolahan Data</option>
                      </select>
                    </div>
                    <div className='mb-24'>
                      <label htmlFor='message' className='text-neutral-700 text-lg fw-medium mb-12'>
                        Detail Kebutuhan
                      </label>
                      <textarea
                        id='message'
                        className='common-input rounded-24 border-transparent focus-border-main-600 h-110'
                        placeholder='Jelaskan kebutuhan penelitian Anda...'
                        defaultValue={""}
                      />
                    </div>
                    <div className='mb-0'>
                      <button type='submit' className='btn btn-main rounded-pill flex-center gap-8 mt-40'>
                        Kirim Permintaan Konsultasi
                        <i className='ph-bold ph-arrow-up-right d-flex text-lg' />
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactInner;
